import React from 'react';
import { Link } from "gatsby"

import WhiteLogo from "../../assets/images/cimplify-white-logo.svg"
import Shape16 from "../../assets/images/shape/shape16.png"

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer-area">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-footer-widget">
                            <Link to="/" className="logo">
                                <img src={WhiteLogo} alt="logo" />
                            </Link>
                            <p>At cimplify.ai, we help companies harness the power of artificial intelligence to drive growth, enhance productivity, improve efficiency and scale operations.</p>

                            <ul className="social-link">
                                 <li><a href="https://www.linkedin.com/company/cimplify-ai/" className="d-block" target="_blank"><i className='bx bxl-linkedin'></i></a></li>
                                 <li><a href="https://www.youtube.com/@cimplifyai" className="d-block" target="_blank"><i className='bx bxl-youtube'></i></a></li>
                                 <li><a href="https://www.instagram.com/cimplify.ai/" className="d-block" target="_blank"><i className='bx bxl-instagram'></i></a></li>
                                 {/* <li><a href="https://twitter.com/cimplifyai" className="d-block" target="_blank"><i className='bx bxl-twitter'></i></a></li> */}
                                 
                                 
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-6 col-sm-6">
                        <div className="single-footer-widget pl-2">
                            <h3>Solutions</h3>

                            <ul className="footer-links-list">
                                <li>
                                    <Link to="/marketing-ai">Marketing AI</Link>
                                </li>
                                <li>
                                    <Link to="/manufacturing-ai">Manufacturing AI</Link>
                                </li>
                                <li>
                                    <Link to="/Retail & eCommerce AI">Retail & eCommerce AI</Link>
                                </li>
                                <li>
                                    <Link to="/Sports & Fitness AI">Sports & Fitness AI</Link>
                                </li>
                               
                            </ul>
                        </div>
                    </div>

                    <div className="col-lg-2 col-md-6 col-sm-6">
                        <div className="single-footer-widget pl-5">
                            <h3>Services</h3>

                            <ul className="footer-links-list">
                                <li>
                                    <Link to="/vision-artifical-intelligence-services">Vision AI</Link>
                                </li>
                                <li>
                                    <Link to="/ai-in-conversations">Conversational AI</Link>
                                </li>
                                <li>
                                    <Link to="/natural-language-nlp-services">Natural Language AI</Link>
                                </li>
                                <li>
                                    <Link to="/predictive-artificial-intelligence-services">Predictive AI</Link>
                                </li>
                              
                                <li>
                                    <Link to="/ai-ml-app-development-services">AI/ML App Development</Link>
                                </li>
                            </ul>
                        </div>
                    </div>

                    

                    <div className="col-lg-4 col-md-6 col-sm-6">
                        <div className="single-footer-widget">
                            <h3>Address</h3>

                            <ul className="footer-contact-info">
                                <li>
                                    <i className='bx bx-map'></i> 
                                    No.627, 6th Floor, EA Chambers Tower II,<br /> No.49/50L, Whites Road, Royapettah,<br /> Chennai - 600014.
                                </li>
                                <li>
                                    <i className='bx bx-phone-call'></i> 
                                    <a href="tel:+914466282286">+91 44 6628 2286</a> <br />
                                    <a href="tel:+917305551108">+91 730 555 1108</a> 
                                    
                                </li>
                               
                                <li>
                                    <i className='bx bx-envelope'></i>
                                    <a href="mailto:info@cimplify.ai">info@cimplify.ai</a>
                                </li>
                                
                                <li>
                                    <i className='bx bx-calendar-plus'></i>
                                    <a href="https://bauhqgl2qlc.typeform.com/to/aqsFPh1j"><u>Get Started</u></a>
                                </li>
                                
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom-area">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-6">
                            <p><i className='bx bx-copyright'></i>{currentYear} <strong>cimplify.ai</strong></p>
                        </div>

                       
                    </div>
                </div>
            </div>

            <div className="shape16">
                <img src={Shape16} alt="Shape" />
            </div>
        </footer>
    );
}

export default Footer;